<template>
    <div class="body">
        <div class="filter">
            <el-row v-if="moreState == true" class="mb20">
                <el-col :span="5">
                    <div class="filter-col">
                        <label>姓名</label>
                        <el-input v-model="params.personalName" placeholder="请输入姓名" clearable></el-input>
                    </div>
                </el-col>
                <el-col :span="6">
                    <div class="filter-col">
                        <label>序号</label>
                        <el-input v-model="params.studentId" placeholder="请输入学生序号" clearable></el-input>
                    </div>
                </el-col>
                <el-col :span="6">
                    <div class="filter-col">
                        <label>报考院校</label>
                        <el-select v-model="params.school" filterable  placeholder="请选择学校" clearable>
                            <el-option label="全部" :value="null"></el-option>
                            <el-option label="数据为空项" :value="''"></el-option>
                            <el-option
                                    v-for="(item,index) in schoolList"
                                    :key="index"
                                    :label="item"
                                    :value="item">
                            </el-option>
                        </el-select>
                    </div>
                </el-col>
                <el-col :span="6">
                    <div class="filter-col">
                        <label>入学形式</label>
                        <el-select v-model="params.enrollWay" placeholder="请选择入学形式" clearable>
                            <el-option label="全部" :value="null"></el-option>
                            <el-option label="数据为空项" :value="''"></el-option>
                            <el-option
                                    v-for="(item,index) in enrollWayList"
                                    :key="index"
                                    :label="item"
                                    :value="item">
                            </el-option>
                        </el-select>
                    </div>
                </el-col>
            </el-row>
            <el-row v-if="moreState == true" style="margin-bottom: 20px">
                <el-col :span="5">
                    <div class="filter-col">
                        <label>专业</label>
                        <el-input v-model="params.major" placeholder="请输入专业" clearable></el-input>
                    </div>
                </el-col>
                <el-col :span="6">
                    <div class="filter-col">
                        <label>审核状态</label>
                        <el-select v-model="params.enrollStatus" placeholder="请选择审核状态" clearable>
                            <el-option label="全部状态" :value="null"></el-option>
                            <el-option label="待提交" value="1"></el-option>
                            <el-option label="待审核" value="2"></el-option>
                            <el-option label="审核通过" value="3"></el-option>
                            <el-option label="驳回" value="4"></el-option>
                        </el-select>
                    </div>
                </el-col>
                <el-col :span="6">
                    <div class="filter-col">
                        <label>数据查重</label>
                        <el-select v-model="params.onlyDuplicatedData" placeholder="请选择数据查重" clearable>
                            <el-option label="显示所有数据" value="0"></el-option>
                            <el-option label="仅显示重复数据" value="1"></el-option>
                        </el-select>
                    </div>
                </el-col>
                <el-col :span="6" v-if="creatorList.length > 0">
                    <div class="filter-col">
                        <label>创建机构</label>
                        <el-select v-model="params.creatorId" filterable  placeholder="请选择创建机构" clearable>
                            <el-option label="全部" :value="null"></el-option>
                            <el-option
                                    v-for="(item,index) in creatorList"
                                    :key="index"
                                    :label="item.username"
                                    :value="item.id">
                            </el-option>
                        </el-select>
                    </div>
                </el-col>
            </el-row>
            <el-row v-if="moreState == true" style="margin-bottom: 10px">
              <el-col :span="5" v-if="roleName =='超级管理员' || roleName=='分校审核账号' ">
                <div class="filter-col">
                  <label>数据年份</label>
                  <el-select v-model="params.year" filterable  placeholder="请选择数据年份" clearable>
                    <el-option
                        v-for="(item,index) in dataYearList"
                        :key="item.yearId"
                        :label="item.value"
                        :value="item.value">
                    </el-option>
                  </el-select>
                </div>
              </el-col>
              <el-col :span=" (roleName =='超级管理员' || roleName=='分校审核账号') ? 6 : 5">
                <div class="filter-col">
                  <label>录取状态</label>
                  <el-select v-model="params.admitStatus" filterable  placeholder="请选择录取状态" clearable>
                    <el-option
                        v-for="(item,index) in AdmissionStatusList"
                        :key="item.id"
                        :label="item.value"
                        :value="item.id">
                    </el-option>
                  </el-select>
                </div>
              </el-col>
              <el-col :span="6">
                <div class="filter-col">
                  <label>注册状态</label>
                  <el-select v-model="params.registStatus" filterable  placeholder="请选择注册状态" clearable>
                    <el-option
                        v-for="(item,index) in RegistStatusList"
                        :key="item.id"
                        :label="item.value"
                        :value="item.id">
                    </el-option>
                  </el-select>
                </div>
              </el-col>
              <el-col :span="6">
                <div class="filter-col">
                  <label>身份证号</label>
                  <el-input v-model="params.idNumber" placeholder="请输入身份证号" clearable></el-input>
                </div>
              </el-col>
            </el-row>
            <div class="flex-end">
              <el-button type="button" v-if="moreState == false" @click="moreState = true">展开</el-button>
              <el-button type="button" v-if="moreState == true" @click="moreState = false">收起</el-button>
              <el-button type="primary" @click="handleSearch">查询</el-button>
            </div>
        </div>

        <div class="data-box">
            <div class="modify-box">
                <div style="display: flex">
                    <el-button class="modify-button" type="primary" @click="handleAdd"
                        v-if="allowAction.indexOf('create') != -1">新建</el-button>
                    <el-button class="modify-button" type="primary" @click="handleDownloadImportTemplate">下载批量导入模板</el-button>
                    <el-upload
                            style="margin: 0 10px"
                            :action="uploadUrl"
                            :http-request="uploadFile"
                            :before-upload="(file) => beforeFileUpload(file)"
                            :data="postData"
                            :show-file-list="false">
                        <el-button type="primary" v-if="allowAction.indexOf('create') != -1">批量导入</el-button>
                    </el-upload>
                    <el-button class="modify-button" type="primary" @click="handleBatchSubmit"
                               v-if="allowAction.indexOf('submit') != -1">批量提交</el-button>
                    <el-button class="modify-button" type="primary" @click="handlePass"
                               v-if="allowAction.indexOf('audit') != -1">批量通过</el-button>
                    <el-button class="modify-button" type="primary" v-if="allowAction.indexOf('admit') != -1" @click="handleDownloadAdmitTemplate">下载批量录取模板</el-button>
                    <el-upload
                            style="margin: 0 10px"
                            :action="uploadUrl"
                            :http-request="uploadAdmitFile"
                            :before-upload="(file) => beforeFileUpload(file)"
                            :data="postData"
                            :show-file-list="false">
                        <el-button type="primary" v-if="allowAction.indexOf('admit') != -1">批量录取</el-button>
                    </el-upload>
<!--                  <el-button class="modify-button" type="primary" @click="handleAdmission"-->
<!--                               v-if="allowAction.indexOf('audit') != -1">批量录取</el-button>-->
                  <el-button class="modify-button" type="primary" @click="handleRegists"
                               v-if="allowAction.indexOf('regist') != -1">批量注册缴费</el-button>
                    <el-button class="modify-button" type="primary" @click="handleDownload"
                               v-if="allowAction.indexOf('download') != -1">批量下载</el-button>
                  <el-button class="modify-button" type="primary" v-if="allowAction.indexOf('download') != -1" @click="handleDownloadAdmitSchool"
                  >下载录取院校导入模板
                  </el-button>
                  <el-upload
                      style="margin: 0 10px"
                      :action="uploadUrl"
                      :http-request="uploadFileSchool"
                      :before-upload="(file) => beforeFileUpload(file)"
                      :data="postData"
                      :show-file-list="false">
                    <el-button class="modify-button" type="primary" v-if="allowAction.indexOf('create') != -1"
                    >批量导入录取院校模板
                    </el-button>
                  </el-upload>
                </div>
                <div>
                    <el-button class="modify-button" type="primary" @click="handleExport"
                               v-if="allowAction.indexOf('export') != -1">导出</el-button>
                </div>
            </div>
            <div class="list-box">
                <el-table
                        v-loading="loading"
                        :data="list"
                        stripe
                        style="width: 100%"
                        height="90%"
                        @selection-change="handleSelectionChange">
                    <el-table-column
                            type="selection"
                            width="55">
                    </el-table-column>
                    <el-table-column
                            label="序号"
                            prop="id"
                            align="center"
                            fixed
                            min-width="60">
                    </el-table-column>
                    <el-table-column
                            v-for="(item,index) in columnList"
                            :key="item.id"
                            :label="item.name"
                            align="center"
                            :width="item.type==3?180:null"
                            :fixed="index==0?true:false"
                    >
                        <template slot-scope="scope">
                            <div v-if="item.type == 6 &&
                            getFormItem(item.id,scope.row) != '---'" class="img-box">
                                <el-image :src="getFormItem(item.id,scope.row)" :preview-src-list="previewImg"/>
                            </div>
                            <div v-else-if="item.type == 7 &&
                            getFormItem(item.id,scope.row) != '---'" >
                                <div class="link-box">
                                    <el-link
                                            type="primary"
                                            :disabled="!getFormItem(item.id,scope.row) || getFormItem(item.id,scope.row) == '---'"
                                            :href="getFormItem(item.id,scope.row)"
                                            v-if="allowAction.indexOf('download') != -1">下载文件</el-link>
                                </div>
                            </div>
                            <div v-else>{{getFormItem(item.id,scope.row)}}</div>
                        </template>
                    </el-table-column>
                    <el-table-column
                            label="创建机构"
                            prop="creatorUsername"
                            align="center"
                            min-width="100">
                    </el-table-column>
                    <el-table-column
                            label="创建者"
                            prop="creatorPersonalName"
                            align="center"
                            min-width="100">
                    </el-table-column>
                    <el-table-column
                            label="创建时间"
                            prop="createTime"
                            align="center"
                            min-width="160">
                    </el-table-column>
                    <el-table-column
                            label="更新时间"
                            prop="updateTime"
                            align="center"
                            min-width="160">
                    </el-table-column>
                    <el-table-column
                            label="审核状态"
                            prop="enrollStatus"
                            :formatter="getEnrollStatus"
                            align="center"
                            min-width="100">
                    </el-table-column>
                  <!--                  todo-->
                    <el-table-column
                            label="录取状态"
                            prop="AdmissionStatus"
                            :formatter="getAdmissionStatus"
                            align="center"
                            min-width="100">
                    </el-table-column>
                  <el-table-column
                            label="注册状态"
                            prop="AdmissionStatus"
                            :formatter="getRegistStatus"
                            align="center"
                            min-width="100">
                    </el-table-column>
                  <!--                  todo-->
                    <el-table-column
                            label="操作"
                            align="center"
                            fixed="right"
                            width="260"
                            v-if="optionStatus"
                    >
                        <template slot-scope="scope">
                            <div class="flex-middle flex-center">
                                <el-button
                                        class="btn-style"
                                        size="mini"
                                        type="text"
                                        v-show="scope.row.enrollStatus == 1"
                                        @click="handleSubmit(scope.row.id)"
                                        v-if="allowAction.indexOf('submit') != -1"
                                >提交</el-button>
                                <el-button
                                        class="btn-style"
                                        size="mini"
                                        type="text"
                                        style="color: #F56C6C"
                                        v-show="scope.row.enrollStatus == 2"
                                        @click="handleAccept(scope.row.id)"
                                        v-if="allowAction.indexOf('audit') != -1"
                                >审核通过</el-button>
                                <el-button
                                        class="btn-style"
                                        size="mini"
                                        type="text"
                                        style="color: #F56C6C"
                                        v-show="scope.row.enrollStatus == 2"
                                        @click="handleRejectEdit(scope.row.id,scope.row.rejectReason)"
                                        v-if="allowAction.indexOf('audit') != -1"
                                >驳回</el-button>
                                <el-button
                                        class="btn-style"
                                        size="mini"
                                        type="text"
                                        v-show="scope.row.enrollStatus == 4"
                                        @click="handleSubmit(scope.row.id)"
                                        v-if="allowAction.indexOf('submit') != -1"
                                >重新提交</el-button>
                              <el-button
                                        class="btn-style"
                                        size="mini"
                                        type="text"
                                        v-show="scope.row.enrollStatus == 4"
                                        @click="handleRejectView(scope.row.id,scope.row.rejectReason)"
                                        v-if="allowAction.indexOf('submit') != -1"
                                >驳回原因</el-button>
                              <el-button
                                        class="btn-style"
                                        size="mini"
                                        type="text"
                                        v-show="(scope.row.enrollStatus == 3 && scope.row.admitStatus ==1) || (roleName=='超级管理员' && scope.row.enrollStatus == 3 && scope.row.admitStatus ==2)|| (roleName=='分校审核账号' && scope.row.enrollStatus == 3 && scope.row.admitStatus ==2)"
                                        @click="handleAdmissionAccept(scope.row.id)"
                                        v-if="allowAction.indexOf('admit') != -1"
                                >已录取</el-button>
                              <el-button
                                        class="btn-style"
                                        size="mini"
                                        type="text"
                                        style="color: #F56C6C"
                                        v-show="(scope.row.enrollStatus == 3 && scope.row.admitStatus ==1) || (roleName=='超级管理员' && scope.row.enrollStatus == 3 && scope.row.admitStatus ==3)|| (roleName=='分校审核账号' && scope.row.enrollStatus == 3 && scope.row.admitStatus ==3)"
                                        @click="handleAdmissionReject(scope.row.id)"
                                        v-if="allowAction.indexOf('admit') != -1"
                                >未录取</el-button>
                              <el-button
                                        class="btn-style"
                                        size="mini"
                                        type="text"
                                        style="color: #F56C6C"
                                        v-show="(scope.row.admitStatus == 3 && roleName=='招生老师' && scope.row.registStatus != 1) || (scope.row.admitStatus == 3 && roleName !='招生老师' )"
                                        @click="handleRegist(scope.row.id,scope.row.registStatus)"
                                        v-if="allowAction.indexOf('regist') != -1"
                                >注册反馈</el-button>
                                <el-button
                                        class="btn-style"
                                        size="mini"
                                        type="text"
                                        @click="handleDownload(scope.row)"
                                        v-if="allowAction.indexOf('download') != -1"
                                >下载</el-button>
                                <el-button
                                        class="btn-style"
                                        size="mini"
                                        type="text"
                                        @click="handleView(scope.row)"
                                >查看</el-button>
                                <el-button
                                        class="btn-style"
                                        size="mini"
                                        type="text"
                                        v-show="((scope.row.enrollStatus == 1 || scope.row.enrollStatus == 4) && scope.row.creatorId == creatorId) || (scope.row.enrollStatus == 3 && scope.row.creatorId != creatorId )"
                                        @click="handleEdit(scope.row)"
                                        v-if="allowAction.indexOf('edit') != -1"
                                >编辑</el-button>
                                <el-button
                                        class="btn-style"
                                        size="mini"
                                        type="text"
                                        style="color: #F56C6C"
                                        v-show="((scope.row.enrollStatus == 1 || scope.row.enrollStatus == 4) && scope.row.creatorId == creatorId) || (scope.row.enrollStatus == 3 && scope.row.creatorId != creatorId )"
                                        @click="handleDelete(scope.row)"
                                        v-if="allowAction.indexOf('delete') != -1"
                                >删除</el-button>
                            </div>
                        </template>
                    </el-table-column>
                </el-table>

                <!--分页-->
                <div class="t_m m10">
                    <el-pagination
                            background
                            @size-change="handleSizeChange"
                            @current-change="handleCurrentChange"
                            :current-page.sync="params.pageNum"
                            :page-sizes="[50, 100, 200]"
                            :page-size="params.pageSize"
                            layout="total,sizes, prev, pager, next"
                            :total="pageTotal">
                    </el-pagination>
                </div>
            </div>
        </div>
        <AddDataDialog v-on:fetchData="fetchData" ref="AddDataDialog"></AddDataDialog>
        <RejectReasonDialog v-on:fetchData="fetchData" ref="RejectReasonDialog"></RejectReasonDialog>
        <SelectRegistDialog v-on:fetchData="fetchData" ref="SelectRegistDialog"></SelectRegistDialog>
    </div>
</template>

<script>
    import Utils from '@/assets/js/Utils'
    import AddDataDialog from './components/AddDataDialog'
    import RejectReasonDialog from './components/RejectReasonDialog'
    import SelectRegistDialog from './components/SelectRegistDialog'

    export default {
        name: 'DataManage',
        components: {AddDataDialog,RejectReasonDialog,SelectRegistDialog},
        data() {
            return {
                allowAction: [],
                optionStatus: true,
                creatorId: null,
                params: {
                    pageNum: 1,
                    pageSize: 50,
                    personalName: null,
                    studentId: null,
                    school: null,
                    creatorId: null,
                    major: null,
                    idNumber: null,
                    enrollStatus: null,
                    onlyDuplicatedData: null,
                    enrollWay: null,
                    year:new Date().getFullYear(),//默认选中当前年份
                    admitStatus:'',//录取状态
                    registStatus:'',//注册状态
                },
                loading: true,
                list: [],
                pageTotal: null,
                columnList: [],

                genderList: [],
                schoolList: [],
                creatorList: [],
                enrollWayList: [],
                dataYearList:[
                  {
                    yearId:1,
                    value:new Date().getFullYear()
                  },{
                    yearId:2,
                    value:new Date().getFullYear()-1
                  },{
                    yearId:3,
                    value:new Date().getFullYear()-2
                  },{
                    yearId:4,
                    value:new Date().getFullYear()-3
                  },
                ],
              AdmissionStatusList:[
                  {
                    id:1,
                    value:'未知'
                  },{
                    id:2,
                    value:'未录取'
                  },{
                    id:3,
                    value:'已录取'
                  },
                ],
              RegistStatusList:[
                  {
                    id:1,
                    value:'注册缴费'
                  },{
                    id:2,
                    value:'不注册'
                  },{
                    id:3,
                    value:'其他'
                  },{
                    id:4,
                    value:'未知'
                  },
                ],

                exportList: [],
                previewImg: [],

                postData: {},
                uploadUrl: Urls.URL.data_url+'/import',
                admitUrl: Urls.URL.data_url+'/batchAdmit',
              uploadUrlSchool:Urls.URL.data_url+'/batchUpdateSchool',
                //收起展开状态
                moreState:true,
                roleName:''
            }
        },
        mounted(){
          console.log(new Date().getFullYear())
            this.fetchData()
            this.allowAction = Utils.checkMenuOprate('enroll.data')
            this.creatorId = JSON.parse(this.$store.state.userInfo).id
            this.roleName = JSON.parse(this.$store.state.userInfo).roleName
            console.log('测试roleName',this.roleName)
            for(let i = 0;i<this.allowAction.length; i++) {
                let item = this.allowAction[i]
                if(item == 'edit' || item == 'audit' || item == 'download' || item == 'submit') {
                    this.optionStatus = true
                    return
                }
            }
            this.optionStatus = false
        },
        methods: {
          //导入学校模板
          uploadFileSchool(item){
            //创建form对象
            let param = new FormData(); //创建form对象
            param.append('file', item.file)
            axios.post(this.uploadUrlSchool,param).then(response => {
              this.$alert(response.data)
              this.fetchData()
            }, (error) => {
              if(error && error.message && !error.response.data.success){
                this.$alert(error.response.data.errorMessage)
              }else{
                if(error && error.message && !error.response.data.success){
                  this.$alert(error.response.data.errorMessage)
                }else{
                  if(error && error.message && !error.response.data.success){
                    this.$alert(error.response.data.errorMessage)
                  }else{
                    this.$alert(error && error.message || '导入失败')
                  }
                }
              }
            })
          },
          //下载学校模板
          handleDownloadAdmitSchool(){
            const loading = this.$loading({
              lock: true,
              text: '下载请求中',
              spinner: 'el-icon-loading',
              background: 'rgba(0, 0, 0, 0.7)'
            });
            axios.get(Urls.URL.data_url + '/admitSchool/template', {
              responseType: 'blob',
              headers: {'Content-Type': 'application/json;application/octet-stream'},
            }).then((response) => {
              loading.close()
              const fileName = decodeURI(response.headers['content-disposition'].split('=')[1])
              let blob = new Blob([response.data], {
                type: "application/zip"
              })
              Utils.downloadFile(URL.createObjectURL(blob), fileName)
            }, (error) => {
              loading.close()
              this.$alert('下载异常')
            })
          },
            //注册审核
            handleRegist(id,status){
              this.$refs.SelectRegistDialog && this.$refs.SelectRegistDialog.setMaskVisible(true, id,status);
              // axios.post(Urls.URL.data_url+'/'+id+'/acceptAdmit').then(res => {
              //   this.fetchData()
              // }).catch(err => {
              //   this.$alert(err.response.data.errorMessage || Utils.errorText)
              // })
            },
            //录取通过
            handleAdmissionAccept(id){
              axios.post(Urls.URL.data_url+'/'+id+'/acceptAdmit').then(res => {
                this.fetchData()
              }).catch(err => {
                this.$alert(err.response.data.errorMessage || Utils.errorText)
              })
            },
            //录取驳回
            handleAdmissionReject(id){
              axios.post(Urls.URL.data_url+'/'+id+'/rejectAdmit').then(res => {
                this.fetchData()
              }).catch(err => {
                this.$alert(err.response.data.errorMessage || Utils.errorText)
              })
              },
            handleSelectionChange(val) {
                this.exportList = val
            },

            getEnrollStatus(val) {
                switch (val.enrollStatus) {
                    case 1:return '待提交';break
                    case 2:return '待审核';break
                    case 3:return '审核通过';break
                    case 4:return '被驳回';break
                }
            },
          //todo
          getAdmissionStatus(val) {
            switch (val.admitStatus) {
              case 1:return '未知';break
              case 2:return '未录取';break
              case 3:return '已录取';break
              // case 4:return '驳回';break
            }
          },
          getRegistStatus(val) {
            switch (val.registStatus) {
              case 1:return '注册缴费';break
              case 2:return '不注册';break
              case 3:return '其他';break
              case 4:return '未知';break
              // case 4:return '驳回';break
            }
          },
            getFormItem(itemId,data) {
                if(data.items) {
                    let item = data.items.find(res => {
                        if(res.formItemId === itemId) {
                            return res
                        }else {
                            return null
                        }
                    })
                    return item && item.value?item.value:'---'
                }
                return '---'
            },

            handleSizeChange(val) {
                this.params.pageSize = val
                this.loading = true
                this.fetchData()
            },

            handleCurrentChange(val) {
                this.params.pageNum = val
                this.loading = true
                this.fetchData()
            },

            handleSearch() {
                this.loading = true
                this.fetchData()
            },

            async fetchData() {
                let params = {
                    ...this.params
                }
                params.major = this.params.major === 'null' ?'':this.params.major === ''?null:this.params.major
                await axios.post(Urls.URL.data_url + '/list',params).then(res => {
                    this.list = []
                    if(res.status == '200') {
                        this.list = [...res.data.data.rows]
                        this.pageTotal = res.data.data.count
                        // 将列表中图片加载进预览列表里
                        this.previewImg = []
                        this.list.forEach(item => {
                            if(item.items && item.items.length > 0) {
                                item.items.forEach(value => {
                                    if(value.formItem.type == 6 && value.value) {
                                        this.previewImg.push(value.value)
                                    }
                                })
                            }
                        })
                        // 动态查询所有列表头
                         axios.get(Urls.URL.form_url,{params:{pageSize: 1000,pageNum: 1}}).then(res => {
                            if(res.status == '200') {
                                this.columnList = res.data.data.rows
                                this.loading = false
                                this.columnList.forEach(item => {
                                    if(item.name == '报考院校') {
                                        this.schoolList = item.ruleConfig.split(',')
                                    }
                                    if(item.name == '入学形式') {
                                        this.enrollWayList = item.ruleConfig.split(',')
                                    }
                                })
                            }
                        }).catch(err => {
                             this.loading = false
                             console.log(err)
                             // this.$alert(err.response.data.errorMessage || Utils.errorText)
                        })
                        // 查询是否有查看用户权限
                        let allowAction = Utils.checkMenuOprate('system.account')
                        if(allowAction && allowAction.length > 0 && allowAction.indexOf('view') != -1) {
                            axios.get(Urls.URL.account_url,{params:{pageSize:1000,pageNum:1}}).then(res => {
                                if(res.status == '200') {
                                    this.creatorList = res.data.data.rows
                                }
                            }).catch(err => {
                                this.$alert(err.response.data.errorMessage || Utils.errorText)
                            })
                        }

                    }
                }).catch(err => {
                    this.$alert(err.response.data.errorMessage || Utils.errorText)
                })


            },

            handleAdd() {
                this.$refs.AddDataDialog && this.$refs.AddDataDialog.setMaskVisible(true, {}, 0);
            },

            handleDownloadImportTemplate() {
                axios.get(Urls.URL.data_url + '/import/template', {
                    responseType: 'blob',
                }).then((response) => {
                    let blob = new Blob([response.data], {
                        type: "application/vnd.ms-excel;charset=utf-8"
                    })
                    Utils.downloadFile(URL.createObjectURL(blob), `批量导入模板.xlsx`)
                }, (error) => {
                    this.$alert(error.response.data.errorMessage || Utils.errorText)
                })
            },

            handleDownloadAdmitTemplate() {
                axios.get(Urls.URL.data_url + '/admit/template', {
                    responseType: 'blob',
                }).then((response) => {
                    let blob = new Blob([response.data], {
                        type: "application/vnd.ms-excel;charset=utf-8"
                    })
                    Utils.downloadFile(URL.createObjectURL(blob), `批量录取模板.xlsx`)
                }, (error) => {
                    this.$alert(error.response.data.errorMessage || Utils.errorText)
                })
            },

            // 批量导入
            // 提交文件之前，设置post参数
            beforeFileUpload(file) {    //在图片提交前进行验证
                let index = file.name.lastIndexOf('.')
                let suffix = file.name.substring(index + 1)
                const isExcel = suffix === 'xls' || suffix === 'xlsx'
                if (!isExcel) this.$message.error('只能上传Excel表格');
                return isExcel
            },

            // 上传文件方法
            uploadFile(item) {
                //创建form对象
                let param = new FormData(); //创建form对象
                param.append('file', item.file)

                axios.post(this.uploadUrl, param)
                    .then(response => {
                        this.$alert(response.data)
                        this.fetchData()
                    }, (error) => {
                      if(error && error.message && !error.response.data.success){
                        this.$alert(error.response.data.errorMessage)
                      }else{
                        this.$alert(error && error.message || '导入失败')
                      }
                    })
            },
            // 上传批量录取文件方法
            uploadAdmitFile(item) {
                //创建form对象
                let param = new FormData(); //创建form对象
                param.append('file', item.file)
                axios.post(this.admitUrl, param)
                    .then(response => {
                        this.$alert(response.data)
                        this.fetchData()
                    }, (error) => {
                      if(error && error.message && !error.response.data.success){
                        this.$alert(error.response.data.errorMessage)
                      }else{
                        this.$alert(error && error.message || '导入失败')
                      }
                    })
            },

            handlePass() {
                let studentIds = []
                this.exportList.forEach(item => {
                    if(item.enrollStatus === 2) {
                        studentIds.push(item.id)
                    }
                })
                if(studentIds.length > 0) {
                    axios.post(Urls.URL.data_url + '/accept',{studentIds}).then(res => {
                        this.fetchData()
                    }).catch(err => {
                        this.$alert(err.response.data.errorMessage || Utils.errorText)
                    })
                } else {
                    this.fetchData()
                }
            },
          //批量录取
          handleAdmission() {
                let studentIds = []
                this.exportList.forEach(item => {
                    if(item.enrollStatus === 3 && item.admitStatus ===1) {
                        studentIds.push(item.id)
                    }
                })
                if(studentIds.length > 0) {
                    axios.post(Urls.URL.data_url + '/acceptAdmit',{studentIds}).then(res => {
                        this.fetchData()
                    }).catch(err => {
                        this.$alert(err.response.data.errorMessage || Utils.errorText)
                    })
                } else {
                    this.fetchData()
                }
            },
          //批量注册
          handleRegists() {
                let studentIds = []
                this.exportList.forEach(item => {
                    if(item.admitStatus===3) {
                        studentIds.push(item.id)
                    }
                })
                if(studentIds.length > 0) {
                    axios.post(Urls.URL.data_url + '/updateRegist/'+1,{studentIds}).then(res => {
                        this.fetchData()
                    }).catch(err => {
                        this.$alert(err.response.data.errorMessage || Utils.errorText)
                    })
                } else {
                    this.fetchData()
                }
            },

            handleDownload(data) {
                let studentIds = []
                let params = {}
                if(data.id) {
                    studentIds.push(data.id)
                    params.byIds = studentIds
                } else if(this.exportList.length > 0) {
                    this.exportList.forEach(item => {
                        studentIds.push(item.id)
                    })
                    params.byIds = studentIds
                } else {
                    params.byParams = {...this.params}
                }
                params.withAttachment = true
                const loading = this.$loading({
                    lock: true,
                    text: '下载请求中',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                });
                axios.post(Urls.URL.data_url + '/download',params,{
                    responseType: 'blob',
                    headers: {'Content-Type':'application/json;application/octet-stream'},
                }).then((response) => {
                    loading.close()
                    const fileName = decodeURI(response.headers['content-disposition'].split('=')[1])
                    let blob = new Blob([response.data], {
                        type: "application/zip"
                    })
                    Utils.downloadFile(URL.createObjectURL(blob), fileName)
                }, (error) => {
                    loading.close()
                    this.$alert('下载异常')
                })
            },

            handleExport() {
                let studentIds = []
                let params = {}
                if(this.exportList.length==0) {
                    params.byParams = {...this.params}
                } else {
                    this.exportList.forEach(item => {
                        studentIds.push(item.id)
                    })
                    params.byIds = studentIds
                }
                const loading = this.$loading({
                    lock: true,
                    text: '下载请求中',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                });
                axios.post(Urls.URL.data_url + '/download',params,{
                    responseType: 'blob',
                }).then((response) => {
                    loading.close()
                    const fileName = decodeURI(response.headers['content-disposition'].split('=')[1])
                    let blob = new Blob([response.data], {
                        type: "application/vnd.ms-excel;charset=utf-8"
                    })
                    Utils.downloadFile(URL.createObjectURL(blob), fileName)
                }, (error) => {
                    loading.close()
                    this.$alert(error.response.data.errorMessage || Utils.errorText)
                })
            },

            handleSubmit(id) {
                axios.post(Urls.URL.data_url+'/'+id+'/submit').then(res => {
                    this.fetchData()
                }).catch(err => {
                    this.$alert(err.response.data.errorMessage || Utils.errorText)
                })
            },

            handleBatchSubmit() {
                if (!this.exportList || this.exportList.length === 0) {
                    this.$alert('请先勾选需要提交的记录')
                    return
                }
                const studentIds = []
                this.exportList.forEach(item => {
                    if (item.enrollStatus === 1 || item.enrollStatus === 4) {
                        studentIds.push(item.id)
                    }
                })
                if (studentIds.length === 0) {
                    this.$alert('所选记录中没有待提交或需重新提交的数据')
                    return
                }
                axios.post(Urls.URL.data_url + '/submit', { studentIds }).then(res => {
                    this.fetchData()
                }).catch(err => {
                    this.$alert((err.response && err.response.data && err.response.data.errorMessage) || Utils.errorText)
                })
            },

            handleAccept(id) {
                axios.post(Urls.URL.data_url+'/'+id+'/accept').then(res => {
                    this.fetchData()
                }).catch(err => {
                    this.$alert(err.response.data.errorMessage || Utils.errorText)
                })
            },

          handleRejectEdit(id,rejectReason) {
              this.$refs.RejectReasonDialog && this.$refs.RejectReasonDialog.setMaskVisible(true, id, 1,rejectReason);
              //   axios.post(Urls.URL.data_url+'/'+id+'/reject').then(res => {
              //       this.fetchData()
              //   }).catch(err => {
              //       this.$alert(err.response.data.errorMessage || Utils.errorText)
              //   })
            },
          handleRejectView(id,rejectReason) {
              this.$refs.RejectReasonDialog && this.$refs.RejectReasonDialog.setMaskVisible(true, id, 2,rejectReason);
              //   axios.post(Urls.URL.data_url+'/'+id+'/reject').then(res => {
              //       this.fetchData()
              //   }).catch(err => {
              //       this.$alert(err.response.data.errorMessage || Utils.errorText)
              //   })
            },

            handleView(data) {
                this.$refs.AddDataDialog && this.$refs.AddDataDialog.setMaskVisible(true, data, 2);
            },

            handleEdit(data) {
                this.$refs.AddDataDialog && this.$refs.AddDataDialog.setMaskVisible(true, data, 1);
            },

            handleDelete(data) {
                this.$confirm(`数据“${data.items[0].value}”正在被删除，是否确定`, '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    axios.delete(Urls.URL.data_url+'/'+data.id).then(res => {
                        this.fetchData()
                    }).catch(err => {
                        this.$alert(err.response.data.errorMessage || Utils.errorText)
                    })
                }).catch(() => {
                    return
                });
            },
        }
    }
</script>

<style scoped lang="stylus">
    .body {
        width 100%
        height 100%
        padding-top 20px
        flex 1
        box-sizing border-box
        display flex
        flex-direction column
    }

    .filter {
        padding 20px 20px 10px 20px
        background-color white
        margin-bottom 20px
        font-size 12px
        .filter-col {
            display flex
            align-items center
            >label {
                width 14%
                min-width 65px
                text-align right
                display inline-block
                padding 0 8px
            }
            >.el-input {
                flex 1
                min-width 120px
            }
            >.el-select {
                flex 1
                min-width 120px
            }
        }
        >>> .el-input {
            font-size 12px
        }

        >>> .el-button {
            padding 9px 20px
            font-size 12px
        }
    }

    .data-box {
        flex 1
        background-color white
        display flex
        flex-direction column
        overflow auto
        .modify-box {
            padding 10px 20px
            display flex
            align-items center
            justify-content space-between
            >>> .el-button {
                padding 9px 20px
                font-size 12px
            }
        }
        .list-box {
            flex 1
            padding 0 25px
            .img-box {
                width 35%
                margin 0 auto
                >img {
                    width 100%
                    height 100%
                }
            }
            .link-box {
                width 100%
                height 40px
            }
        }
    }


    .mb20 {
        margin-bottom 20px
    }

    .flex-end {
        flex 1
        display flex
        justify-content flex-end
        padding-right 20px
    }

    >>> .el-table {
        font-size 12px
    }
</style>
